export default __webpack_public_path__ + "static/media/delete_document.3d836572.svg";